<template>
<div class="create-dialog-container">
  <el-dialog :visible.sync="API.createDialog.dialogVisible" v-if="API.createDialog.dialogVisible" title="挂载设备" width="500px">
    <div>
      <el-select v-model="selectedDevice">
        <el-option v-for="(item, index) of deviceList" :key="index" :label="item.name" :value="item.id.id"></el-option>
      </el-select>
      <el-button @click="mount">挂载</el-button>
      <br>
      <br>
      <el-button @click="submit">完成</el-button>
    </div>
  </el-dialog>
</div>
</template>

<script>
import { getUnmountedDevice, mountDeviceToGateway } from '@/api/device-controller'
import { removeSlash } from '@/utils/removeIdSlash'

export default {
  name: 'MountDeviceDialog',
  props: ['API'],
  data () {
    return {
      deviceList: [],
      selectedDevice: ''
    }
  },
  methods: {
    async submit () {
      this.API.createDialog.dialogVisible = false
      this.API.getData()
    },
    async mount () {
      await mountDeviceToGateway({
        deviceId: removeSlash(this.selectedDevice),
        gatewayId: this.API.createDialog.currentGateway
      })
      this.$message.success('挂载成功')
    }
  },
  async created () {
    const resp = await getUnmountedDevice()
    this.deviceList = resp.data
    this.selectedDevice = this.deviceList[0].id.id
  }
}
</script>

<style lang="scss" scoped>
</style>
